/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Rythme de prélèvement d'une rémunération.
 * @export
 */
export const TypePrelevement = {
    /**
    * Une seule fois à la première cotisation
    */
    Unique: 1,
    /**
    * À chaque échéance annuelle du contrat
    */
    AEcheance: 2,
    /**
    * Montant annuel divisé selon le fractionnement
    */
    FractionneAnnuel: 3,
    /**
    * Montant appliqué à chaque prélèvement
    */
    FractionneParPrelevement: 4
} as const;
export type TypePrelevement = typeof TypePrelevement[keyof typeof TypePrelevement];


export function instanceOfTypePrelevement(value: any): boolean {
    for (const key in TypePrelevement) {
        if (Object.prototype.hasOwnProperty.call(TypePrelevement, key)) {
            if (TypePrelevement[key as keyof typeof TypePrelevement] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TypePrelevementFromJSON(json: any): TypePrelevement {
    return TypePrelevementFromJSONTyped(json, false);
}

export function TypePrelevementFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypePrelevement {
    return json as TypePrelevement;
}

export function TypePrelevementToJSON(value?: TypePrelevement | null): any {
    return value as any;
}

export function TypePrelevementToJSONTyped(value: any, ignoreDiscriminator: boolean): TypePrelevement {
    return value as TypePrelevement;
}

